import type { DispatchWithoutAction } from 'react';
import { useReducer } from 'react';

export function useMisbehavedForceUpdate(): DispatchWithoutAction {
	// https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
	const [_, forceUpdate] = useReducer((x) => x + 1, 0);

	return forceUpdate;
}
